<template>
  <div class="select-reason">
    <div class="container">
      <div class="select-title">更优质的服务选择</div>
      <div class="select-subtitle">精益求精，专业靠谱的年会策划老师。精挑细选实地考察的星标酒店和特色场地。安全可靠的舞台搭建、灯光音效、落地执行的服务人员。</div>
      <div class="good-employees">
        <div class="employee" v-for="item in plannerList" :key="item.id">
          <div class="employee-head">
            <div class="head-left">
               <div class="name">
                {{item.name}}
              </div>
               <div class="job">
               {{item.job_title?item.job_title:'年会策划师'}} 
              </div>              
            </div>
            <div class="head-right" v-bind:style="{backgroundImage:'url('+'\''+item.image +'\''+')'}">

            </div>
          </div>
          <div class="employee-bottom">
            <div class="triangle"></div>
            <div class="introduct">
              {{item.description}}
            </div>
          </div>
        </div>
      </div>
    <div class="card-content">
          <div v-for="(item,index) in iconList" :key="index" class="card-content-item" v-bind:style="{backgroundImage:'url(' +'\'' + item.path +'\'' + ')'}">
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handlePicPlusPre} from "@/util/util.js";
export default {
  name:"adDetails",
  components: {
    
  },
  props: {},
  data() {
    return {
      id: null,
      message: {},
      isShowPicTxt:-1,
      iconList:[],
      isShowPicTxtleft:0,
      plannerList:[],
    };
  },
  watch: {},
  computed: {
        // 获取站点城市id
    getLocationSiteCityId() {
      return this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5;
    },
  },
  methods: {
    handlePicPlusPre,
    // 获取年会策划师图片
    getPlannerList(){
      const params = {
        type:1
      }
      axios
        .get(`/api/planner/list`, {
          params
        })
        .then((res) => {
          console.log(res)
          if(res.data &&res.data.code == 200){
              this.plannerList = res.data.plannerList;
            if(this.plannerList){
              this.plannerList.forEach(planner=>{
                planner.image =  handlePicPlusPre(planner.image);
              })
            }
          }
        })
    },
    //
    getIconList(){
      const params = {
        positionId:11
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          console.log(res)
          if(res.data &&res.data.code == 200){
              this.iconList = res.data.adList;
            if(this.iconList){
              this.iconList.forEach(banner=>{
                banner.path =  handlePicPlusPre(banner.path);
              })
            }
          }
        })
    }
  },
  created() {
    
  },
  mounted() {
    this.getIconList();
    this.getPlannerList();
  }
};
</script>
<style scoped>
.select-reason{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  height: 100%;
  width: 100%;
  background: #fff;
}
.select-reason .container{
  width: 1060px;
  /* position:absolute; */
  height: 770px;  
}
.container .select-title{
    font-family: PingFangSC-Regular;
    font-size: 38px;
    color: #201f1f;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 30px;
}

.container .select-subtitle{
    position: absolute;
    left: 50%;
    margin-left: -363px;
    width: 726px;
    font-size: 18px;
    color: #959595;
    text-align: center;
    margin-bottom: 20px;
}
.container .good-employees{
    font-family: PingFangSC-Regular;
    font-size: 38px;
    color: #201f1f;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 30px;
    margin-top: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.container .employee{
    width: 326px;
    height: 240px;
    display: flex;
    flex-direction: column;
}
.employee .employee-head{
  /* flex:3; */
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
}
.employee .head-left{
    display: flex;
    flex-direction: column;
    margin-right: 20px;
}
.employee .head-left .name{
  font-size: 16px;
  color: #201f1f;
  font-weight: 700;
  margin-bottom: 10px;
}
.employee .head-left .job{
  font-size: 14px;
  color: #666;
}
.employee .head-right{
    width: 70px;
    height: 70px;
    display: block;
    border-radius: 35px;
    background: #efefef;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50%;
    /* position: absolute;
    right: 20px;
    top: 100px; */
}
.employee .employee-bottom{
  /* flex:4; */
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  /* justify-content: space-between; */
}
.employee-bottom .triangle{
    position: relative;
    right: -15px;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-right: 15px solid transparent;
    border-left: 28px solid #ddd;
    color: #666;
    margin-left: 30px;
}
.employee-bottom .introduct{
    /* position: absolute; */
    background: #f9f9f9;
    /* left: 0;
    top: 195px;
    right: 0; */
    border-radius: 10px 0 10px 5px;
    padding: 30px 34px 20px;
    font-size: 14px;
    color: #666;
}
.card-content{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.card-content-item{
    width: 250px;
    height: 134px;
    background: #efefef;
    margin-bottom: 20px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: cover;
}




</style>


// WEBPACK FOOTER //
// src/components/annualMeeting/selectReason.vue